import { ActionBar, CheckCircleIcon, T3 } from 'ia-react-core';
import styled from 'styled-components';

export const StyledDiv = styled.div`
  text-align: center;
 `;

export const StyledCheckCircleIcon = styled(CheckCircleIcon)`
  color: ${({ theme }) => theme.colors.green10};
  height: 60px;
  width: 60px;
  text-align: center;
 `;

export const StyledActionBar = styled(ActionBar)`
  align-items: center;
 `;

export const StyledT3 = styled(T3)`
  margin-bottom: 16px;
`;
